namespace TabAurous.OMS {
    export namespace LabourPriceListDetailsService {
        export const baseUrl = 'OMS/LabourPriceListDetails';

        export declare function Create(request: Serenity.SaveRequest<LabourPriceListDetailsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<LabourPriceListDetailsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<LabourPriceListDetailsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<LabourPriceListDetailsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetLabor(request: LaborRateRequest, onSuccess?: (response: Serenity.ListResponse<LabourPriceListDetailsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "OMS/LabourPriceListDetails/Create",
            Update = "OMS/LabourPriceListDetails/Update",
            Delete = "OMS/LabourPriceListDetails/Delete",
            Retrieve = "OMS/LabourPriceListDetails/Retrieve",
            List = "OMS/LabourPriceListDetails/List",
            GetLabor = "OMS/LabourPriceListDetails/GetLabor"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'GetLabor'
        ].forEach(x => {
            (<any>LabourPriceListDetailsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
